import { useArbiterClient } from '../context/ArbiterClientContext';
import { usePaginatedApi } from './usePaginatedApi';
import type { GuidanceCatalogEntry } from '@amzn/helianthus-arbiter-client';

interface UseGuidanceCatalogResult {
  entries: GuidanceCatalogEntry[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useGuidanceCatalog(): UseGuidanceCatalogResult {
  const client = useArbiterClient();

  const { data, loading, error, refetch } = usePaginatedApi(
    (fetchParams) =>
      client.listGuidanceCatalog(fetchParams).then((r) => ({
        items: r.entries ?? [],
        continuationToken: r.continuationToken,
      })),
    {},
  );

  return { entries: data, loading, error, refetch };
}
